module.exports = __webpack_public_path__ + "img/e_2_6_g.dbb28891.png";